import React from "react";
import { Link, graphql, useStaticQuery } from "gatsby";
import { buildBreadcrumbTrail, categoryStrapiId } from "./trail";

const Breadcrumbs = ({ category, size = "lg", disableClick = true }) => {
  const data = useStaticQuery(query);
  const categoryId = categoryStrapiId(category);
  if (!categoryId) {
    return (<></>);
  }

  const trail = buildBreadcrumbTrail(data.allStrapiCategory.nodes, categoryId);
  const linkClass = `uppercase font-semibold text-gray-800 underline text-${size}`;

  return (
    <nav className="flex flex-wrap items-center">
      <Link to="/" className={linkClass}>
        Inicio
      </Link>
      {trail.length > 0 && (
        <span className="mx-2 font-semibold text-gray-800">/</span>
      )}
      {trail.map((crumb, index) => {
        // Les ancêtres restent cliquables (ce sont des raccourcis de
        // navigation) ; seule la catégorie courante suit `disableClick`.
        const isCurrent = index === trail.length - 1;
        return isCurrent && disableClick === true ? (
          <span key={crumb.strapiId} className={linkClass}>
            {crumb.name}&nbsp;/&nbsp;
          </span>
        ) : (
          <a key={crumb.strapiId} href={crumb.url} className={linkClass}>
            {crumb.name}&nbsp;/&nbsp;
          </a>
        );
      })}
    </nav>
  );
};

const query = graphql`
  query {
    allStrapiCategory {
      nodes {
        slug
        id
        name
        strapiId
        strapiParent {
          id
        }
        strapiChildren{
          id
        }
        products {
          id
        }
      }
    }
  }
`;

export default Breadcrumbs;
